export default {
  bkash__how_to_pay: 'কীভাবে পেমেন্ট করবেন?',
  bkash__make_payment_first: 'প্রথমে পেমেন্ট করুন',
  bkash__amount_label: 'পরিমাণ',
  bkash__step_copy_agent: 'আপনার অ্যাকাউন্ট নম্বরের জায়গাটি থেকে পেমেন্ট/এজেন্ট নম্বর কপি করুন',
  bkash__agent_number_label: 'বিকাশ এজেন্ট নম্বর:',
  bkash__step_open_app: 'বিকাশ অ্যাপে যান, তারপর “ক্যাশ আউট” নির্বাচন করুন',
  bkash__step_paste_account: 'অ্যাকাউন্ট নম্বর পেস্ট করুন এবং “এজেন্ট থেকে” নির্বাচন করুন।',
  bkash__step_enter_trx:
    'তারপর, ট্রানজেকশন আইডি কপি করুন এবং ট্রানজেকশন আইডির জায়গাটিতে সেটা পেস্ট করুন',
  bkash__trx_placeholder: 'ট্রানজেকশন নম্বর – AA**',
  bkash__trx_tooltip: 'আপনার বিকাশ লেনদেনের পর যে\n' + 'আইডিটি পাবেন তা এখানে লিখুন',
  bkash__agent_tooltip:
    'এটি একটি এজেন্ট নাম্বার অনুমোদন করে আপনার বিকাশ অ্যাপে পেমেন্ট অপশন ব্যবহার করুন।',
  bkash__trx_error: 'Only Latin letters and digits are allowed. No spaces or special characters.',
  bkash__confirm: 'নিশ্চিত করুন',

  // Status page
  bkash_status__success_title: 'পেমেন্ট সফল হয়েছে',
  bkash_status__success_subtitle: 'লেনদেন সফলভাবে সম্পন্ন হয়েছে',
  bkash_status__processing_title: 'প্রসেসিং হচ্ছে',
  bkash_status__processing_subtitle: 'লেনদেনটি প্রক্রিয়াধীন রয়েছে',
  bkash_status__expired_title: 'সেশনের সময় শেষ',
  bkash_status__expired_subtitle: 'নিরাপত্তার কারণে আপনার সেশনের সময় শেষ হয়ে গেছে',
  bkash_status__failed_title: 'লেনদেন ব্যর্থ হয়েছে।',
  bkash_status__failed_subtitle: 'একটি পেমেন্টের চেষ্টা সম্পন্ন হয়নি।',
  bkash_status__payment_details: 'পেমেন্টের বিস্তারিত',
  bkash_status__payment_date: 'পেমেন্টের তারিখ',
  bkash_status__initiation_date: 'পেমেন্টের তারিখ',
  bkash_status__invoice_ref: 'Invoice/Reference',
  bkash_status__return_btn: 'ওয়েবসাইটে ফিরে যান',
  bkash_status__footer_text: '© 2025 bKash, All Rights Reserved',
};
